<script setup lang="ts">
import { CategoryPage } from '@/types/api/api-v4/category'
import { NewProduct } from '@/types/api/api-v4/product'

import MainCategoryFactoid from '@/components/Main/MainCategoryFactoid.vue'
import ProductList from '@/components/Product/ProductList.vue'

type Props = {
  currentCategory: CategoryPage
  filteredProducts: NewProduct[]
  isLoading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  filteredProducts: () => [],
})

const route = useRoute()

const { isDesktop, isTablet, isMobile } = useResponsive()

const factoidLength = computed(() => {
  // Вычисляем число активных фактоидов(1 фактоид из списка
  // на три продукта на странице
  // также проверка на то чтобы всегда остовался 1 фактоид если фактоидов
  // в изначальном списке больше 0
  const productsLength = props.filteredProducts.length
  let factoidsLength = props.currentCategory.factoids.length

  if (factoidsLength !== 0) {
    while (productsLength / factoidsLength < 3) {
      factoidsLength--
    }
  }

  if (factoidsLength === 0 && props.currentCategory.factoids.length !== 0) {
    factoidsLength = 1
  }

  if (productsLength === 0) {
    factoidsLength = 0
  }

  return factoidsLength
})

const factoidStyles = computed(() => {
  const styles: string[] = []
  let row = 0
  let column = 4
  let gridStyle

  // Стили для активных фактоидов
  for (let i = 1; i <= factoidLength.value; i++) {
    if (isDesktop.value || i === 1) {
      row++
    } else if (isTablet.value) {
      row += 2
    }

    if (i % 2 === 0) {
      column = isDesktop.value ? 4 : 2

      if (isMobile.value) {
        row += 2
      }
    } else {
      column = 1

      if (isMobile.value && i !== 1) {
        row += 3
      }

      if (isTablet.value && i !== 1) {
        column = 2
      }
    }

    gridStyle = 'grid-row:' + row + '; grid-column:' + column + ';'
    styles.push(gridStyle)
  }
  return styles
})

const factoidMap = computed(() => {
  if (route.name === 'filter-category' || !props.currentCategory?.factoids) {
    return []
  }

  return props.currentCategory.factoids.slice(0, factoidLength.value) || []
})
</script>

<template>
  <product-list
    class="category-products"
    :products="filteredProducts"
    :is-loading="isLoading"
  >
    <div
      v-for="(factoid, index) in factoidMap"
      :key="factoid.url"
      class="category-products__factoid"
      :style="factoidStyles[index]"
    >
      <main-category-factoid :factoid="factoid" is-category-page />
    </div>
  </product-list>
</template>

<style lang="scss" scoped>
.category-products {
  &__factoid {
    grid-row: 1;
    height: 100%;
    min-height: 392px;

    @include media('<=desktop-mini') {
      min-height: auto;
    }
  }
}
</style>
